import { StatusEnums } from "@typings/enums";

/** Helper function to get the status heading for subscribe page. */
export const getSubscribeStatusHeading = (status: StatusEnums): string => {
  switch (status) {
    case StatusEnums.Loading:
      return "Updating your subscriptions.";
    case StatusEnums.Success:
      return "You've been subscribed!";
    case StatusEnums.Error:
      return "We're sorry about that.";
  }
};

/** Helper function to get the status description for subscribe page. */
export const getSubscribeStatusDescription = (status: StatusEnums): string => {
  switch (status) {
    case StatusEnums.Loading:
      return "Please wait while we update your newsletter subscriptions.";
    case StatusEnums.Success:
      return "You will start receiving your newsletters soon. For more BT newsletters, please visit <a href='https://www.businesstimes.com.sg/newsletters/sign-up'>this page</a>.";
    case StatusEnums.Error:
      return "There was an error updating your subscriptions. Please try again.";
  }
};
